export const ORGANIC_COTTON_BABY_DOLL_COLOR_MAP: {
  [tone: string]: string;
} = {
  'Light Skin Tone': '#F0C8B1',
  'Tan Skin Tone': '#C78D6B',
  'Dark Skin Tone': '#5F423A',
};
